export type AppMode = 'combined' | 'landing-only'

function normalizeAppMode(rawMode: string | undefined): AppMode {
  if (!rawMode) {
    return 'combined'
  }

  return rawMode.trim().toLowerCase() === 'landing-only' ? 'landing-only' : 'combined'
}

export function getAppMode(): AppMode {
  const env = import.meta.env as Record<string, string | undefined>
  return normalizeAppMode(env.VITE_APP_MODE)
}

export function isLandingOnlyMode(): boolean {
  return getAppMode() === 'landing-only'
}

export function getLandingHomePath(): '/' | '/welcome' {
  return isLandingOnlyMode() ? '/' : '/welcome'
}
